import { FormControl, Typography } from "@mui/material";
import { useField } from "formik";
import React from "react";
import DatePicker from "react-date-picker";
import { capitalize } from "lodash";
import styles from './datepicker.module.css'

interface Props {
  label?: string;
  subLabel?: string;
  noLabel?: boolean;
  name: string;
  required?: boolean;
}
export function FieldDatePicker({
  label,
  subLabel,
  noLabel,
  name,
  required,
}: Props) {
  const [field, meta, helpers] = useField(name);
  const { ...restField } = field;

  const calendarClassName = styles["date-picker-calendar-container"];

  return (
    <FormControl
      className="flex flex-col gap-2 w-full relative min-h-[90px]"
      fullWidth
    >
      {!noLabel && (
        <Typography variant="body1" color="var(--text)">
          {label || capitalize(name)}
          {subLabel && <span className="text-muted"> ({subLabel})</span>}
          {required && <span className="ml-2 text-text-2">*</span>}
        </Typography>
      )}

      <DatePicker
        format="MM/dd/yyyy"
        {...restField}
        className="h-[40px] rounded-xl bg-surface-2"
        calendarClassName={calendarClassName}
        onChange={(value: Date) => {
          helpers.setValue(value);
        }}
      />

      {!!meta.touched && !!meta.error && (
        <div className="-bottom-0 absolute">
          <Typography variant="caption" color="error">
            {meta.error}
          </Typography>
        </div>
      )}
    </FormControl>
  );
}
